import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { selectTeams } from "../../../../redux/slices/teamsSlice";
import SelectedTeamRoleCard from "./SelectedTeamRoleCard";
import { setAppShowRemainingForm } from "../../../../redux/slices/appSettingsSlice";

const ConnectedSelectedTeamRoleCard = ({ ...props }) => {
    const { values, handleChange } = useFormikContext();
    const { Team } = values;
    const dispatch = useDispatch();
    const teams = useSelector(selectTeams);
    const selectedTeam = teams.find((team) => `${team.id}` === Team);
    const { title } = selectedTeam;

    const description =
        selectedTeam.id === "new-team"
            ? "You"
            : selectedTeam?.captains?.reduce((_captains, captain, i) => {
                  const { name } = captain;
                  const nameString = `${i > 0 ? ", " : ""}${name}`;

                  // eslint-disable-next-line no-return-assign, no-param-reassign
                  return (_captains += nameString);
              }, "");
    const isSelected = Object.keys(selectedTeam).length !== 0;

    useEffect(() => {
        if (isSelected && Team) {
            dispatch(setAppShowRemainingForm(true));
        }
    }, [isSelected, Team, dispatch]);

    const selectTeamRoleCardProps = {
        title,
        description,
        isSelected,
        handleChange,
        ...props,
    };

    return <SelectedTeamRoleCard {...selectTeamRoleCardProps} />;
};

export default ConnectedSelectedTeamRoleCard;
